import { Observable } from "rxjs";  
import HttpService from "./HttpService";  
import { url } from "./APIEndPoints"; 
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPIItemsGridModel } from "../interfaces/IAPIItemsGridModel";
import { IAPISelectedItemsRequest } from "../interfaces/IAPIDonationAndItemModel";

class ItemService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getItems(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIItemsGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<IAPIItemsGridModel[]>>(
      url.getAllItems,
      params
    );
  }

  getAvailableTypes(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    filterBy: string,
    searchValue: string,
    includeDonations: boolean = false,
    sourceId?: string
  ): Observable<IAPIResponse<IAPISelectedItemsRequest[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
      filterBy: filterBy,
      includeDonations: includeDonations,
      sourceId: sourceId || "",
    });
    return this.httpService.get<IAPIResponse<IAPISelectedItemsRequest[]>>(
      url.getAvailableTypes,
      params
    );
  }
}

export default new ItemService();
